import { getIconUrl } from "@/lib/directus";
import Image from "next/image";
import React from "react";
import { LazyMotion, domAnimation, m } from "framer-motion";

export interface ImageLinksProps {
  data: ImageLinkData;
}

interface ImageLinkData {
  item: any[];
}

export default function ImageLinks({ data }: ImageLinksProps) {
  let images = data.item.map((image) => image.item);
  return (
    <LazyMotion features={domAnimation}>
      <div className="bg-accent-color-three">
      <section className="max-w-[85vw] mx-auto mx-[7.5vw]">
        <div className="w-full flex flex-nowrap justify-between items-center gap-6 desktop:gap-16 py-8">
          {images.map((image, index) => (
            <a
              key={index}
              href={image.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center"
              style={{ textDecoration: "none" }}
            >
              <m.div
                className="flex items-center justify-center"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                }}
              >
                <Image
                  src={getIconUrl(image.image)}
                  alt={`Award ${index + 1}`}
                  width={180}
                  height={100}
                  className="object-contain h-[40px] md:h-[60px] desktop:h-[100px] w-auto filter brightness-0 invert"
                  quality={100}
                  sizes="(max-width: 768px) 100px, (max-width: 1200px) 140px, 180px"
                />
              </m.div>
            </a>
          ))}
        </div>
      </section>
    </div>
    </LazyMotion>
  );
}
